import { render } from "./NuovoRapportino.vue?vue&type=template&id=389c1c88&scoped=true"
import script from "./NuovoRapportino.vue?vue&type=script&lang=js"
export * from "./NuovoRapportino.vue?vue&type=script&lang=js"

import "./NuovoRapportino.vue?vue&type=style&index=0&id=389c1c88&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_energy-saving_1764367324033741919/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-389c1c88"]])

export default __exports__